var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSteps(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 25,
    viewBox: "0 0 15 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2657 11.7919L12.3083 12.6464L13.932 12.9455L13.9746 11.8348L12.2657 11.7919Z",
    fill: "#6D2AFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0263 11.6641L10.7701 12.3902L9.14649 12.2622L9.48822 11.0657L11.0263 11.6641Z",
    fill: "#6D2AFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2657 13.0312L12.3083 13.8002L13.761 14.7401L13.9319 13.5012L12.2657 13.0312Z",
    fill: "#6D2AFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9663 13.1597L11.4964 14.0568L11.1117 13.0741L11.9663 13.1597Z",
    fill: "#6D2AFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.685 12.9454L10.6424 13.5435L8.93319 14.099L8.89054 13.3727L9.0614 12.689L10.685 12.9454Z",
    fill: "#6D2AFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2657 14.2274L11.8384 14.6974L12.5648 16.4492L13.0773 16.1074L13.5473 15.5093L12.2657 14.2274Z",
    fill: "#6D2AFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5818 14.8255L11.0692 14.6973L10.2146 16.5773L10.9836 16.919H11.71L11.5818 14.8255Z",
    fill: "#6D2AFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8553 14.5269L9.53079 16.0222L8.84735 14.7403L10.6418 13.9287L10.8553 14.5269Z",
    fill: "#6D2AFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8638 7.56274L12.992 6.87903L14.9146 7.39188L14.7009 8.54527L12.8638 7.56274Z",
    fill: "#6D2AFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0347 6.45162L12.9492 5.51172L15 5.68258L14.9574 6.87888L13.0347 6.45162Z",
    fill: "#6D2AFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9489 4.99865L12.821 4.18701L14.9145 3.88794L14.9998 4.48608V5.12687L12.9489 4.99865Z",
    fill: "#6D2AFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6928 3.71709L12.4364 2.9481L14.2735 2.17883L14.6581 3.28985L12.6928 3.71709Z",
    fill: "#6D2AFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3082 2.60614L12.0518 2.22177L13.2481 0.384399L13.5045 0.640826L13.7183 0.897253L13.9318 1.6236L12.3082 2.60614Z",
    fill: "#6D2AFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8386 2.0935H11.454L10.984 0.128213L11.6677 0H12.1803L12.6076 0.170862L11.8386 2.0935Z",
    fill: "#6D2AFF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1979 2.13619L10.8989 2.56348L9.48882 1.32453L9.95875 0.726391L10.5142 0.384399L11.1979 2.13619Z",
    fill: "#6D2AFF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0096 6.19559L11.2832 6.15267L10.8988 5.25548L11.1124 4.44385L12.0523 4.4865L12.3513 5.21285L12.0096 6.19559Z",
    fill: "#6D2AFF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3083 3.93061L11.881 2.81986L11.4537 2.69165L10.9411 3.58884L10.8555 4.18698L12.0947 4.10142L12.3083 3.93061Z",
    fill: "#6D2AFF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2224 6.83618H11.1973L11.2399 7.13526L11.5816 7.69075L11.8381 7.77605L12.1798 7.09261L12.2224 6.83618Z",
    fill: "#6D2AFF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M10.685 2.94801L9.01875 1.87964L8.54882 3.07594L10.4715 3.67408L10.685 2.94801Z",
    fill: "#6D2AFF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3431 4.14453L8.4204 3.84546V5.16996L10.1722 4.95618L10.3431 4.14453Z",
    fill: "#6D2AFF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2147 5.46912L8.37729 5.68263L8.5055 6.83629L10.2573 6.409L10.2147 5.46912Z",
    fill: "#6D2AFF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6424 7.47685L10.4716 6.83606L8.63421 7.4342L8.9762 8.41695L10.6424 7.47685Z",
    fill: "#6D2AFF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M3.28957 19.626L3.33222 20.4805L1.79424 20.9078L1.62337 19.8397L3.28957 19.626Z",
    fill: "#6D2AFF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M4.52831 19.4124L4.82738 20.0958L6.45099 19.7967L5.98105 18.6431L4.52831 19.4124Z",
    fill: "#6D2AFF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M3.41798 20.8654V21.6343L2.09348 22.6598L1.7944 21.4635L3.41798 20.8654Z",
    fill: "#6D2AFF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M3.71669 20.9506L4.27218 21.8051L4.57125 20.7797L3.71669 20.9506Z",
    fill: "#6D2AFF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M4.95543 20.6092L5.08364 21.25L6.79281 21.5918V20.9083L6.53638 20.2246L4.95543 20.6092Z",
    fill: "#6D2AFF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M3.54572 22.0189L3.97301 22.4889L3.41751 24.2836L2.86202 23.9845L2.39208 23.3864L3.54572 22.0189Z",
    fill: "#6D2AFF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2296 22.5744L4.74245 22.4036L5.76792 24.1554L5.04157 24.5827L4.31522 24.6253L4.2296 22.5744Z",
    fill: "#6D2AFF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M4.95543 22.1892L6.40812 23.5993L6.92098 22.2321L5.12625 21.5911L4.95543 22.1892Z",
    fill: "#6D2AFF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M2.34954 15.482L2.17841 14.8412L0.341316 15.5246L0.597742 16.6356L2.34954 15.482Z",
    fill: "#6D2AFF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M2.09341 14.4135V13.5164L0.0851974 13.8154L0.25606 15.0117L2.09341 14.4135Z",
    fill: "#6D2AFF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M2.05084 12.9612L2.09349 12.1922L0 12.064V12.6621L0.0426481 13.3029L2.05084 12.9612Z",
    fill: "#6D2AFF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M2.22113 11.6793L2.39199 10.9529L0.511981 10.3121L0.212906 11.4232L2.22113 11.6793Z",
    fill: "#6D2AFF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M2.47727 10.5681L2.69105 10.1409L1.36655 8.47461L1.11013 8.73077L0.939264 9.02984L0.768402 9.71355L2.47727 10.5681Z",
    fill: "#6D2AFF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M2.90506 10.0127L3.2897 9.97005L3.54613 8.00475L2.90507 7.91919L2.34984 8.00475L1.9652 8.17562L2.90506 10.0127Z",
    fill: "#6D2AFF"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M3.54569 10.0127L3.88742 10.3973L5.12636 9.07283L4.61378 8.47469L4.05828 8.21826L3.54569 10.0127Z",
    fill: "#6D2AFF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M3.07603 14.1148L3.75947 13.9866L4.1012 13.0467L3.80212 12.2775L2.90493 12.4057L2.69142 13.132L3.07603 14.1148Z",
    fill: "#6D2AFF"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M2.60566 11.8928L2.90473 10.7391L3.33202 10.5682L3.93016 11.4228L4.05838 11.978L2.81943 12.0636L2.60566 11.8928Z",
    fill: "#6D2AFF"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M2.90506 14.7129L3.93052 14.6273V14.9264L3.63145 15.5245L3.37529 15.6101L2.948 14.9693L2.90506 14.7129Z",
    fill: "#6D2AFF"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M4.10122 10.7818L5.63948 9.54285L6.23762 10.7391L4.40026 11.4655L4.10122 10.7818Z",
    fill: "#6D2AFF"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M4.52831 11.8927L6.40832 11.4655L6.53653 12.7473L4.78472 12.7044L4.52831 11.8927Z",
    fill: "#6D2AFF"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M4.78513 13.2174L6.62223 13.2601V14.4137L4.82778 14.1573L4.78513 13.2174Z",
    fill: "#6D2AFF"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M4.52831 15.2251L4.65652 14.5844L6.53653 15.0116L6.2801 15.9944L4.52831 15.2251Z",
    fill: "#6D2AFF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteps);
export default __webpack_public_path__ + "static/media/steps.7d7bc06c447d9ba0584ec829ace546aa.svg";
export { ForwardRef as ReactComponent };